// extracted by mini-css-extract-plugin
export default {"container":"WQ-z","darkBackground":"XQ-z","whiteBackground":"YQ-z","headerButton":"ZQ-z","calloutHeading":"_Q-z","calloutSubHeading":"aR-z"};